import _Vue from "vue";
import CopyPaste from "./copyPaste";

const install = (Vue: typeof _Vue) => {
  const copyPaste = new CopyPaste();
  Vue.prototype.$copyPaste = copyPaste;
  (Vue as any).$copyPaste = copyPaste;
}
  
  const plugin = {
      install
  }
  
  export default plugin
